// User directory — populates the client `accounts` list (member management, seat
// counts, masterScope lookups) from the server. Read-only; never has passwords.
import { api } from '../api';

export const accountsStore = {
  async list() {
    const { users } = await api.get('/api/users');
    return users || [];
  },
  // Admin-add a member/agent to an org (server creates the user + seeds inherited
  // reminders). Returns the created user.
  // Members are provisioned password-less — the server emails a setup link. Returns the
  // full response so callers can surface { inviteSent, setupLink } (setupLink dev-only).
  async create({ username, alias, email, orgId, admin, expiresAt, phone, licenseId, mlsBrokerId, appOrigin, inviteSubject, inviteMessage }) {
    return api.post('/api/users', { username, alias, email, orgId, admin, expiresAt, phone, licenseId, mlsBrokerId, appOrigin, inviteSubject, inviteMessage });
  },
  // Patch a member (disabled / expiresAt / profile fields). Returns the full response so
  // callers can see { inviteResent, setupLink } when an invited agent's email changes.
  async update(id, patch) {
    return api.patch(`/api/users/${id}`, patch);
  },
  // Delete a member + their scoped data.
  async remove(id) {
    return api.delete(`/api/users/${id}`);
  },
};
